window.Studio407 = window.Studio407 || {};

(function(Studio) {
  'use strict';

  const EDIT_SESSION_KEY = 'studio407EditSession';

  /**
   * Obtiene la sesión de edición guardada por el carrito.
   */
  Studio.getEditSession = function() {
    if (
  Studio.state &&
  Studio.state.editSession &&
  Studio.state.editSession.lineKey
) {
  return Studio.state.editSession;
}
  try {
    const savedSession = sessionStorage.getItem(EDIT_SESSION_KEY);

    if (!savedSession) return null;

    const session = JSON.parse(savedSession);

    if (!session) {
      return null;
    }

    const lineKey = session.lineKey || session.itemKey;

    if (!lineKey) {
      return null;
    }

    session.lineKey = lineKey;

    return session;
  } catch (error) {
    console.error('407 Studio edit-session error:', error);
    return null;
  }
};

  /**
   * Elimina la sesión después de actualizar correctamente el carrito.
   */
  Studio.clearEditSession = function() {
    try {
      sessionStorage.removeItem(EDIT_SESSION_KEY);
    } catch (error) {
      console.warn('Could not clear 407 Studio edit session:', error);
    }
  };

  /**
   * Determina si una foto necesita volver a subirse.
   *
   * Una foto existente del carrito puede reutilizar su URL mientras
   * no haya sido reemplazada ni editada durante esta sesión.
   */
  Studio.slotNeedsUpload = function(slot) {
    if (!slot) return false;

    if (slot.finalFile) return true;

    if (slot.originalFile && !slot.existingUrl) {
      return true;
    }

    if (slot.replaced === true) {
      return true;
    }

    if (slot.changed === true) {
      return true;
    }

    return false;
  };

  /**
   * Devuelve la URL que ya pertenece a una foto cargada anteriormente.
   */
  Studio.getExistingSlotUrl = function(slot) {
    if (!slot) return '';

    return (
      slot.existingUrl ||
      slot.uploadedUrl ||
      slot.remoteUrl ||
      ''
    );
  };

  /**
   * Verifica que todos los espacios tengan una foto nueva
   * o una URL existente.
   */
  Studio.hasMissingPhotos = function() {
    return Studio.state.slots.some(function(slot) {
      const existingUrl = Studio.getExistingSlotUrl(slot);

      return !slot.originalFile &&
        !slot.finalFile &&
        !slot.image &&
        !existingUrl;
    });
  };

  Studio.addStudioToCart = async function(button) {
    const editSession =
  Studio.state.editSession ||
  Studio.getEditSession();

const isEditMode = Boolean(
  editSession && editSession.lineKey
);

const variantId = isEditMode
  ? Number(editSession.variantId)
  : Studio.getSelectedVariantId();

    if (!variantId) {
      alert('Variant not found.');
      return;
    }

    if (Studio.hasMissingPhotos()) {
      alert('Please add all photos before continuing.');
      return;
    }

    const originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = isEditMode
        ? 'Saving changes...'
        : 'Preparing uploader...';
    }

    try {
      const photoResults = new Array(Studio.state.slots.length);
      const slotsToUpload = [];

      /*
       * Primero identificamos cuáles fotos pueden reutilizarse
       * y cuáles realmente necesitan volver a subirse.
       */
      Studio.state.slots.forEach(function(slot, index) {
        const existingUrl = Studio.getExistingSlotUrl(slot);
        const needsUpload = Studio.slotNeedsUpload(slot);

        if (!needsUpload && existingUrl) {
          photoResults[index] = {
            url: existingUrl,
            uploaded: false
          };

          return;
        }

        slotsToUpload.push({
          slot: slot,
          index: index
        });
      });

      /*
       * Solo inicializamos Upload-Lift cuando existe al menos
       * una foto nueva, reemplazada o editada.
       */
      if (slotsToUpload.length > 0) {
        const uploadField = await Studio.waitForUploadLift();

        for (
          let uploadIndex = 0;
          uploadIndex < slotsToUpload.length;
          uploadIndex += 1
        ) {
          const uploadItem = slotsToUpload[uploadIndex];
          const slot = uploadItem.slot;
          const slotIndex = uploadItem.index;

          if (button) {
            button.textContent =
              `Uploading photo ${uploadIndex + 1} of ${slotsToUpload.length}...`;
          }

          const fileToUpload = await Studio.getFileForUpload(
            slot,
            slotIndex
          );

          const uploadedFile = await uploadField.uploadFile(fileToUpload);

          if (!uploadedFile || !uploadedFile.url) {
            throw new Error(
              `Upload-Lift did not return a URL for photo ${slotIndex + 1}.`
            );
          }

          photoResults[slotIndex] = {
            url: uploadedFile.url,
            uploaded: true
          };
        }
      }

      if (button) {
        button.textContent = isEditMode
          ? 'Updating cart...'
          : 'Adding to cart...';
      }

      /*
 * Replace temporary preview URLs with the permanent
 * Upload-Lift URLs before saving the project to IndexedDB.
 */
photoResults.forEach(function(photo, index) {
  const slot = Studio.state.slots[index];

  if (!slot || !photo || !photo.url) {
    return;
  }

  const permanentUrl = String(photo.url).trim();

  Studio.revokePreviewUrl(slot.image);

  slot.image = permanentUrl;
  slot.originalImage = permanentUrl;

  slot.existingUrl = permanentUrl;
  slot.remoteUrl = permanentUrl;
  slot.uploadedUrl = permanentUrl;

  /*
   * The permanent image is now saved, so it does not
   * need to be uploaded again during the next edit.
   */
  slot.changed = false;
  slot.replaced = false;
});

      /*
 * Save the editable project before sending it to Shopify.
 */
let projectId = Studio.getCartEditorProjectId();

if (typeof Studio.saveCartEditorProject === 'function') {
  const project = await Studio.saveCartEditorProject({
    projectId: projectId,
    lineKey: isEditMode ? editSession.lineKey : null,
    variantId: variantId,
    setSize: Studio.state.setSize
  });

  projectId = project.projectId;
}

      const properties = {
  '407 Studio Order': 'Yes',

  '407 Project ID': projectId,

  'Set Size': String(Studio.state.setSize),

  'Photo Adjustment':
    'Customer edits saved; unedited photos may be professionally adjusted.'
};

      photoResults.forEach(function(photo, index) {
        const slot = Studio.state.slots[index];

        if (!photo || !photo.url) {
          throw new Error(
            `Photo URL missing for magnet ${index + 1}.`
          );
        }

        properties[`Magnet ${index + 1}`] = photo.url;

        properties[`Magnet ${index + 1} Status`] =
          slot.edited === true
            ? 'Edited by customer'
            : 'Professional adjustment requested';
      });

      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      let response;

      /*
       * EDIT MODE:
       * Actualiza la línea existente usando su item key.
       */
      if (isEditMode) {
        response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: editSession.lineKey,
            quantity: 1,
            properties: properties
          })
        });
      } else {
        /*
         * NEW PRODUCT:
         * Añade normalmente una nueva línea al carrito.
         */
        response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            properties: properties
          })
        });
      }

     if (!response.ok) {
  const errorText = await response.text();

  throw new Error(
    errorText ||
    (
      isEditMode
        ? 'Shopify rejected the cart update.'
        : 'Shopify rejected the cart request.'
    )
  );
}

const cartResponse = await response.json();

/*
 * Al cambiar las propiedades, Shopify puede generar
 * una nueva line key. Localizamos la línea usando el
 * Project ID y actualizamos IndexedDB.
 */
if (
  isEditMode &&
  cartResponse &&
  Array.isArray(cartResponse.items)
) {
  const updatedItem = cartResponse.items.find(function(item) {
    return (
      item.properties &&
      item.properties['407 Project ID'] === projectId
    );
  });

  if (
    updatedItem &&
    updatedItem.key &&
    typeof Studio.updateCartEditorProjectLineKey ===
      'function'
  ) {
    await Studio.updateCartEditorProjectLineKey(
      projectId,
      updatedItem.key
    );

    Studio.state.editLineKey = updatedItem.key;

    if (Studio.state.editSession) {
      Studio.state.editSession.lineKey =
        updatedItem.key;
    }
  }
}

Studio.clearEditSession();

if (isEditMode) {
  Studio.destroyCropper();

  const modal =
    document.querySelector('[data-407-modal]');

  if (modal) {
    modal.classList.remove('is-open');
  }

  document.body.style.overflow = '';

  /*
   * Permanecemos dentro de Your Cart.
   * La recarga muestra las nuevas miniaturas y propiedades.
   */
  window.location.reload();

  return;
}

window.location.href = `${root}cart`;
    } catch (error) {
      console.error('407 Studio upload/cart error:', error);

      alert(
        isEditMode
          ? 'We could not save your photo changes. Your photos are still available. Please try again.'
          : 'We could not finish uploading your photos. Please try again.'
      );

      if (button) {
        button.disabled = false;
        button.textContent =
          originalText ||
          (isEditMode ? 'Save Changes' : 'Add To Cart');
      }
    }
  };
})(window.Studio407);